(() => {
  if (customElements.get('cordilheira-desktop-search')) return;
  class DesktopSearch extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.form = this.querySelector('form');
      this.input = this.querySelector('[name="q"]');
      this.panel = this.querySelector('.desktop-search__panel');
      this.idle = this.querySelector('[data-search-idle]');
      this.live = this.querySelector('[data-search-live]');
      this.loading = this.querySelector('[data-search-loading]');
      this.liveCarousel = this.querySelector('[data-live-carousel]');
      this.liveNext = this.querySelector('[data-live-carousel-next]');
      this.status = this.querySelector('[data-search-status]');
      this.viewAll = this.querySelector('[data-search-view-all]');
      this.footer = this.querySelector('[data-search-footer]');
      this.carousel = this.querySelector('[data-search-carousel]');
      this.carouselTrack = this.carousel?.querySelector('.desktop-search__products');
      this.carouselNext = this.carousel?.querySelector('[data-carousel-next]');
      this.updateCarousel = () => {
        if (!this.carouselNext || !this.carouselTrack) return;
        const track = this.carouselTrack;
        this.carouselNext.hidden = this.desktop.matches || this.dataset.mobileProducts !== 'scroll_two' || track.scrollWidth <= track.clientWidth + 1 || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      this.carouselNext?.addEventListener('click', () => {
        const card = this.carouselTrack.querySelector('.desktop-search__product');
        this.carouselTrack.scrollBy({ left: (card?.getBoundingClientRect().width || this.carouselTrack.clientWidth / 2) + 12, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.carouselTrack?.addEventListener('scroll', this.updateCarousel, { ...options, passive: true });
      this.updateLiveCarousel = () => {
        const track = this.live.querySelector('.desktop-search__products');
        if (!this.liveNext) return;
        this.liveNext.hidden = true;
      };
      this.liveNext?.addEventListener('click', () => {
        const track = this.live.querySelector('.desktop-search__products');
        const card = track?.querySelector('.desktop-search__product');
        track?.scrollBy({ left: (card?.getBoundingClientRect().width || track.clientWidth / 2) + 12, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.live.addEventListener('scroll', this.updateLiveCarousel, { ...options, capture: true, passive: true });
      window.addEventListener('resize', () => { this.updateCarousel(); this.updateLiveCarousel(); }, options);
      this.desktop = matchMedia('(min-width: 1150px)');
      this.desktop.addEventListener('change', () => this.updateMobileTyping(), options);
      this.updateMobileTyping();
      this.root = window.Shopify?.routes?.root || '/';
      this.mobileEnabled = this.dataset.mobileEnabled === 'true';
      this.mobileDialog = document.createElement('dialog');
      this.mobileDialog.className = 'desktop-search__mobile-dialog';
      this.mobileDialog.setAttribute('aria-label', 'Buscar na loja');
      this.append(this.mobileDialog);
      this.mobileDialog.addEventListener('click', event => {
        if (event.target !== this.mobileDialog) return;
        // A modal backdrop covers the visible header too. Forward a tap on the
        // menu icon after closing the search so that it remains usable.
        const menu = document.querySelector('store-header [aria-controls="header-sidebar-menu"]');
        const rect = menu?.getBoundingClientRect();
        const onMenu = rect && event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        const searchTrigger = [...document.querySelectorAll('[data-cordilheira-search-trigger]')].find(trigger => trigger.dataset.cordilheiraSearchTrigger === this.dataset.inputId && trigger.getClientRects().length);
        const searchRect = searchTrigger?.getBoundingClientRect();
        const onSearch = searchRect && event.clientX >= searchRect.left && event.clientX <= searchRect.right && event.clientY >= searchRect.top && event.clientY <= searchRect.bottom;
        if (onMenu) {
          event.preventDefault();
          this.close(false);
          requestAnimationFrame(() => menu.click());
        } else if (onSearch) {
          event.preventDefault();
          this.close(false);
        } else {
          this.close(true);
        }
      }, options);
      // Dismiss the mobile keyboard without closing search or cancelling the tap.
      const dismissMobileKeyboard = () => {
        if (!this.desktop.matches && this.hasAttribute('open') && document.activeElement === this.input) {
          this.input.blur();
        }
      };
      this.addEventListener('pointerdown', event => {
        if (!event.composedPath().includes(this.input)) dismissMobileKeyboard();
      }, { ...options, capture: true, passive: true });
      // Listen to the gesture itself: short drags and drags at a scroll boundary
      // do not necessarily produce a scroll event.
      this.addEventListener('touchmove', dismissMobileKeyboard, { ...options, capture: true, passive: true });
      this.addEventListener('wheel', dismissMobileKeyboard, { ...options, capture: true, passive: true });
      this.mobileDialog.addEventListener('cancel', event => { event.preventDefault(); this.close(true); }, options);
      this.mobileDialog.addEventListener('close', () => { if (!this.mobileDialog.open && this.hasAttribute('open')) this.close(); }, options);
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-cordilheira-search-trigger]');
        if (!trigger || trigger.dataset.cordilheiraSearchTrigger !== this.dataset.inputId || this.desktop.matches || !this.mobileEnabled) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.returnFocus = trigger;
        if (this.hasAttribute('open')) this.close(false);
        else this.open();
      }, { ...options, capture: true });
      this.input.addEventListener('focus', () => this.open(), options);
      this.input.addEventListener('click', () => this.open(), options);
      this.input.addEventListener('input', () => {
        this.updateMobileTyping();
        this.open();
        clearTimeout(this.timer);
        this.request?.abort();
        this.version = (this.version || 0) + 1;
        if (!this.input.value.trim()) return this.showIdle();
        this.footer.hidden = false;
        this.loading.hidden = false;
        this.status.textContent = 'Buscando…';
        this.live.hidden = true;
        this.liveCarousel.hidden = true;
        this.idle.hidden = true;
        this.viewAll.hidden = true;
        this.timer = setTimeout(() => this.search(this.version), 280);
      }, options);
      this.form.addEventListener('submit', event => {
        const term = this.input.value.trim();
        if (!term) { event.preventDefault(); this.input.focus({ preventScroll: true }); return; }
        this.remember(term);
      }, options);
      this.querySelector('[data-search-close]').addEventListener('click', () => this.close(true), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.hasAttribute('open')) {
          event.preventDefault(); event.stopPropagation(); this.close(true);
        } else if (event.key === 'ArrowDown' && event.target === this.input && this.hasAttribute('open')) {
          const first = [...this.panel.querySelectorAll('a, button')].find(el => el.getClientRects().length);
          if (first) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.addEventListener('focusout', event => {
        // Mouse activation on macOS can clear focus before the submit click.
        // Outside pointer clicks are already handled below; only close for an explicit focus destination.
        const next = event.relatedTarget;
        if (this.desktop.matches && next && !this.contains(next)) this.close();
      }, options);
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-search-term]');
        if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!event.button || event.button === 0)) {
          event.preventDefault();
          this.input.value = link.dataset.searchTerm;
          this.remember(this.input.value);
          this.open();
          this.input.focus({ preventScroll: true });
          clearTimeout(this.timer);
          this.request?.abort();
          this.version = (this.version || 0) + 1;
          this.footer.hidden = false;
          this.loading.hidden = false;
          this.status.textContent = 'Buscando…';
          this.idle.hidden = true; this.live.hidden = true; this.liveCarousel.hidden = true; this.viewAll.hidden = true;
          this.search(this.version);
        }
        else if (event.target.closest('.desktop-search__product')) this.remember(this.input.value.trim());
      }, options);
      document.addEventListener('pointerdown', event => { if (this.desktop.matches && !this.contains(event.target)) this.close(); }, options);
      this.desktop.addEventListener('change', () => this.close(), options);
      window.addEventListener('resize', () => this.resize(), options);
      window.addEventListener('scroll', () => { if (this.hasAttribute('open')) this.resize(); }, { ...options, passive: true });
      this.renderHistory();
    }
    disconnectedCallback() { this.closingAnimation?.cancel(); document.documentElement.classList.remove('cdlr-desktop-search-open'); this.openingAnimation?.cancel(); this.events?.abort(); this.request?.abort(); clearTimeout(this.timer); if (this.mobileDialog?.open) { document.documentElement.classList.remove('cdlr-mobile-search-open'); this.mobileDialog.close(); } }
    updateMobileTyping() {
      const typing = !!this.input.value.trim();
      this.toggleAttribute('data-search-typing', typing);
      const sidebar = this.querySelector('.desktop-search__sidebar-collapse');
      if (sidebar) sidebar.inert = typing && !this.desktop.matches;
    }
    open() {
      this.updateMobileTyping();
      if (this.suppressFocus || (!this.desktop.matches && !this.mobileEnabled)) return;
      if (this.hasAttribute('open')) return;
      this.closingAnimation?.cancel();
      this.closingAnimation = null;
      this.panel.style.pointerEvents = '';
      this.setAttribute('open', '');
      if (this.desktop.matches) {
        document.documentElement.classList.add('cdlr-desktop-search-open');
        this.closest('store-header')?.querySelectorAll('.header__main-nav details[open], .header__secondary-nav details[open]').forEach(menu => { menu.open = false; });
      }
      this.panel.hidden = false;
      if (!this.desktop.matches) {
        this.mobileDialog.append(this.form);
        const header = this.closest('store-header');
        document.documentElement.classList.add('cdlr-mobile-search-open');
        const headerBottom = Math.max(0, Math.min(window.innerHeight, header?.getBoundingClientRect().bottom || 0));
        document.documentElement.style.setProperty('--cdlr-mobile-header-bottom', `${headerBottom}px`);
        this.mobileDialog.showModal();
        const fromMenu = this.dataset.fromMobileMenu === 'true';
        delete this.dataset.fromMobileMenu;
        this.animateOpening(this.mobileDialog, fromMenu ? 'menu-reveal' : this.dataset.mobileAnimation, false);
        this.input.focus({ preventScroll: true });
        requestAnimationFrame(() => this.updateCarousel());
      }
      this.input.setAttribute('aria-expanded', 'true');
      this.updateTriggers(true);
      this.resize();
      if (this.desktop.matches) this.animateOpening(this.panel, this.dataset.desktopAnimation, true);
      this.dispatchEvent(new Event('toggle', { bubbles: true }));
    }
    animateOpening(target, kind, desktop) {
      this.openingAnimation?.cancel();
      if (!target.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const frames = kind === 'menu-reveal'
        ? [{ opacity: 0, clipPath: 'inset(0 0 100% 0)' }, { opacity: 1, clipPath: 'inset(0)' }]
        : kind === 'fade'
        ? [{ opacity: 0 }, { opacity: 1 }]
        : desktop ? [{ opacity: 0, clipPath: 'inset(0 0 12px 0)' }, { opacity: 1, clipPath: 'inset(0)' }] : [{ opacity: 0, clipPath: 'inset(0 0 100% 0)' }, { opacity: 1, clipPath: 'inset(0)' }];
      this.openingAnimation = target.animate(frames, { duration: kind === 'menu-reveal' ? 400 : desktop ? 220 : 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
    close(restoreFocus = false) {
      if (!this.hasAttribute('open')) return;
      this.openingAnimation?.cancel();
      const wasMobile = this.mobileDialog.open;
      document.documentElement.classList.remove('cdlr-desktop-search-open');
      this.removeAttribute('open');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!wasMobile && !this.panel.hidden && this.panel.animate && !reduceMotion) {
        this.panel.style.pointerEvents = 'none';
        const animation = this.panel.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-out', fill: 'forwards' });
        this.closingAnimation = animation;
        animation.finished.then(() => {
          if (this.closingAnimation !== animation || this.hasAttribute('open')) return;
          this.panel.hidden = true;
          this.panel.style.pointerEvents = '';
          this.closingAnimation = null;
          animation.cancel();
        }).catch(() => {});
      } else {
        this.panel.hidden = true;
        this.panel.style.pointerEvents = '';
      }
      this.input.setAttribute('aria-expanded', 'false');
      this.updateTriggers(false);
      if (wasMobile) { document.documentElement.classList.remove('cdlr-mobile-search-open'); this.mobileDialog.close(); document.documentElement.style.removeProperty('--cdlr-mobile-header-bottom'); }
      if (this.form.parentElement === this.mobileDialog) this.prepend(this.form);
      if (restoreFocus) {
        if (wasMobile) this.returnFocus?.focus({ preventScroll: true });
        else { this.suppressFocus = true; this.input.focus({ preventScroll: true }); this.suppressFocus = false; }
      }
      this.dispatchEvent(new Event('toggle', { bubbles: true }));
    }
    updateTriggers(expanded) {
      for (const trigger of document.querySelectorAll('[data-cordilheira-search-trigger]')) {
        if (trigger.dataset.cordilheiraSearchTrigger === this.dataset.inputId) {
          trigger.setAttribute('aria-expanded', String(expanded));
          trigger.setAttribute('aria-controls', this.panel.id);
        }
      }
    }
    resize() {
      const header = this.closest('.header__wrapper');
      if (header) this.panel.style.setProperty('--desktop-search-available-height', `${Math.max(0, innerHeight - header.getBoundingClientRect().bottom)}px`);
    }
    showIdle() {
      this.updateMobileTyping();
      this.loading.hidden = true;
      this.liveCarousel.hidden = true;
      this.footer.hidden = true;
      this.live.removeAttribute('aria-busy');
      this.idle.hidden = this.idle.hasAttribute('data-search-idle-disabled'); this.live.hidden = true; this.status.textContent = ''; this.viewAll.hidden = true;
      requestAnimationFrame(() => this.updateCarousel());
    }
    async search(version) {
      this.updateMobileTyping();
      const term = this.input.value.trim();
      if (!term) return this.showIdle();
      this.request?.abort();
      this.request = new AbortController();
      this.footer.hidden = false;
      const params = new URLSearchParams({
        q: term, section_id: this.desktop.matches ? this.dataset.resultsSection : 'mobile-search-results',
        type: 'product', 'options[prefix]': 'last'
      });
      this.live.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.root}search?${params}`, { signal: this.request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = html.querySelector('[data-desktop-search-results]');
        if (!results) throw new Error('Missing search results');
        if (version !== this.version || term !== this.input.value.trim()) return;
        this.loading.hidden = true;
        this.live.replaceChildren(...results.childNodes);
        for (const image of this.live.querySelectorAll('.desktop-search__image img')) {
          const frame = image.closest('.desktop-search__image');
          frame.classList.add('is-loading');
          const reveal = () => {
            if (!frame.isConnected) return;
            frame.classList.remove('is-loading');
            frame.classList.add('is-revealed');
          };
          if (image.complete) reveal();
          else {
            image.addEventListener('load', reveal, { once: true });
            image.addEventListener('error', reveal, { once: true });
            // Cover an image completing between the check and listener registration.
            if (image.complete) reveal();
          }
        }
        this.idle.hidden = true; this.live.hidden = false; this.liveCarousel.hidden = false;
        requestAnimationFrame(() => this.updateLiveCarousel());
        const total = results.getAttribute('data-search-total');
        if (!/^\d+$/.test(total || '')) throw new Error('Missing search total');
        const count = Number(total);
        const formatted = new Intl.NumberFormat('pt-BR').format(count);
        const label = count === 1 ? 'resultado' : 'resultados';
        const quotedTerm = document.createElement('span');
        quotedTerm.className = 'desktop-search__result-term';
        quotedTerm.textContent = `“${term}”`;
        this.status.replaceChildren(document.createTextNode(`${formatted} ${label} para `), quotedTerm);
        const arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '→';
        this.viewAll.replaceChildren(document.createTextNode(`Ver ${formatted} ${label} `), arrow);
        this.viewAll.hidden = false;
      } catch (error) {
        if (error.name === 'AbortError' || version !== this.version) return;
        this.loading.hidden = true;
        this.liveCarousel.hidden = true;
        this.idle.hidden = this.idle.hasAttribute('data-search-idle-disabled'); this.live.hidden = true;
        this.footer.hidden = false;
        this.status.textContent = 'Pressione Enter para ver os resultados da busca.';
        this.viewAll.textContent = 'Ver todos os resultados →';
        this.viewAll.hidden = false;
      } finally {
        if (version === this.version) this.live.removeAttribute('aria-busy');
      }
    }
    history() {
      try {
        const value = JSON.parse(localStorage.getItem('cordilheira-search-history') || '[]');
        return Array.isArray(value) ? value.filter(item => typeof item === 'string' && item.trim()).slice(0, 3) : [];
      } catch { return []; }
    }
    remember(term) {
      term = term.trim().slice(0, 100);
      if (!term) return;
      try { localStorage.setItem('cordilheira-search-history', JSON.stringify([term, ...this.history().filter(item => item.toLocaleLowerCase() !== term.toLocaleLowerCase())].slice(0, 3))); } catch { /* Search also works with storage disabled. */ }
      this.renderHistory();
    }
    renderHistory() {
      const list = this.querySelector('[data-search-history]');
      list.replaceChildren();
      const history = this.history();
      this.querySelector('[data-search-recent]').hidden = !history.length || this.querySelector('[data-search-recent]').hasAttribute('data-search-recent-disabled');
      for (const term of history) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `${this.root}search?type=product&q=${encodeURIComponent(term)}`;
        link.dataset.searchTerm = term;
        link.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 5v5l3 2"/></svg>';
        link.append(document.createTextNode(term));
        item.append(link); list.append(item);
      }
    }
  }
  customElements.define('cordilheira-desktop-search', DesktopSearch);
})();
